<div class="flex items-center mobi-ui-font-bold text-signature">
  <mobi-ui-icon-major
    name="hand_thumbs_up"
    class="block w-[24px] h-[24px] rounded-[8px] bg-bg-2 mr-[4px]"
  />
  {{ count() }}
</div>
